import { proxy } from "valtio/vanilla";
import { SiteClusterFeature, SiteFeature as SiteFeatureType } from "src/js/api/siteGeometry.types";

export type SiteFeature = SiteFeatureType;

export type SiteGeometryStore = {
  siteFeatures: SiteFeature[];
  clusters: SiteClusterFeature[];
  boundsDistance: number;
  activeRequestAbort?: AbortController["abort"];
  loading: boolean;
  changeCount: number;
};

export const getInitialSiteGeometryStore = (): SiteGeometryStore => ({
  siteFeatures: [],
  clusters: [],
  boundsDistance: 0,
  loading: false,
  /**
   * This value is observed and used to invalidate the sites map layer when
   * graphql mutations against sites are made.
   *
   * @todo use pub/sub approach instead?
   */
  changeCount: 0,
});

export const siteGeometryStore = proxy<SiteGeometryStore>(getInitialSiteGeometryStore());
